export default __webpack_public_path__ + "cd40122bcf5cac9ae4a0d482c78e3905.svg";